module.exports = __webpack_public_path__ + "arrTop.b354a822.gif";